/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Remove feedback button",
  "description": "Removes the feedback button from the menu bar.",
  "userstyles": [
    {
      "url": "remove-feedback.css"
    }
  ],
  "tags": [
    "danger"
  ],
  "dynamicDisable": true,
  "enabledByDefault": false
};
export default manifest;
